<template>
    <div class="container">
      <form
        :class="{ 'cursor-not-allowed': disabled }"
        enctype="multipart/form-data"
        novalidate
      >
        <div
          class="dropbox"
          :class="{ 'pointer-events-none': disabled }"
          @drop="_onDrop"
          @dragover="_onDragOver"
        >
          <p>
              Arraste os arquivos para esta área <br> ou 
          </p>
          <span
            class="btn btn-primary fileinput-button"
            @click="() => this.$refs.iptFile.click()"
          >
            <span class="fa fa-search">
            </span>
            Pesquise no computador
            <input
              ref="iptFile"
              type="file"
              multiple
              @click="_onClick"
              @change="_onChange"
              accept=".bmp,.doc,.dot,.jpg,.pdf,.png,.xls,.odt,.odf,.rtf,.txt,.xml,.html,.gif,.zip,.rar,.xlsx,.docx,.ppt,.pptx,.7z,.jpeg,.htm,.csv,.qrp,.tdm,.ofx,.ofc"
              class="input-file"
            >
          </span>   
        </div>
      </form>
      <span class="tip-label is-size-7"> <i> {{ tipLabel }} </i></span>
    </div>
</template>

<script>
export default {
    name: "TrfButtonUpLoadAttachment",
    emits: ['uploadFile'],
    props: {
      tipLabel: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },
  methods: {
    _onDrop(e) {
      e.preventDefault();

      const files = e.dataTransfer.files;
      if(!files.length) {
        return;
      }

      const iptFile = this.$refs.iptFile;
      iptFile.files = files;
      const changeEvent = new Event('change');
      iptFile.dispatchEvent(changeEvent);
    },
    _onDragOver(e) {
      e.preventDefault();
    },
    _onClick() {
      this.$refs.iptFile.value = "";
    },
    _onChange(e) {
      if(this.disabled) {
        return;
      }

      this.$emit('uploadFile', e);
    }
  }
}
</script>

<style lang="scss" scoped>
.dropbox {
  text-align: center;
  outline: 3px dashed rgb(207, 207, 207); 
  background: rgb(236, 236, 236);
  color: dimgray;
  padding: 0px 10px;
  margin: 5px 0px;
  min-height: 50px;
  position: relative;
  border-radius: 5px;
}

.btn {
  background:#c22743;
  color:rgb(255, 255, 255);
  padding: 10px;
  min-height: 10px;
  position: relative;
  bottom: 30px;
  border-radius: 5px;
  font-size: 1em;
}

.input-file {
  opacity:0; 
  position: absolute;
  width: 0px;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 30px 0 40px;
  color: #333;
}

.fileinput-button {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.pointer-events-none {
  pointer-events: none;
}

</style>
